import { Text } from "@shopify/polaris"
import { ReactNode } from "react"

import styles from "./MigrateSetupGuideTabContent.module.scss"

interface MigrateSetupGuideTabContentProps {
  header?: ReactNode
  description?: ReactNode
  actions?: ReactNode
  footer?: ReactNode
  media?: ReactNode
}

const MigrateSetupGuideTabContent = ({
  header,
  description,
  actions,
  footer,
  media,
}: MigrateSetupGuideTabContentProps) => {
  return (
    <div className={styles.tabContent}>
      <div className={styles.tabContentMain}>
        <div className={styles.tabContentBody}>
          <div className={"flex flex-col gap-1 w-[532px] max-w-full"}>
            {header ? <div className={styles.tabContentHeader}>
              <Text as={"p"} variant={"headingSm"}>{header}</Text>
            </div> : null}
            {description ? <div className={styles.tabContentDescription}>
              <Text as={"p"} variant={"bodyMd"} tone={"subdued"}>{description}</Text>
            </div> : null}
          </div>
          {actions ? <div className={styles.tabContentActions}>{actions}</div> : null}
          {footer ? <div className={styles.tabContentFooter}>{footer}</div> : null}
        </div>
      </div>
      <div className={styles.tabContentMedia}>
        {media ?? <div className={styles.tabContentMediaPlaceholder} aria-hidden />}
      </div>
    </div>
  )
}

export default MigrateSetupGuideTabContent
